export const blurOnEnter = (event) => {
  if (event.key === "Enter") {
    document.activeElement.blur();
  }
};
